import request from '@/utils/request'

export class UploadAdapter {
  constructor(loader) {
    this.loader = loader
  }

  upload() {
    return this.loader.file
      .then(file => {
        const formData = new FormData()
        formData.append('file', file)
        return request.request({
          url: 'admin/Resources/wangEditor',
          method: 'POST',
          data: formData
        })
      })
      .then(res => {
        return {
          default: res.data
        }
      })
  }

  abort() {}
}
